var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',{scopedSlots:_vm._u([{key:"before-footer",fn:function(){return [_c('k-landing-how-can-you-use-kintell',{staticClass:"mt-10"})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }